/**
 * StatusPill — Score/status badge with built-in dark mode support
 * Used in Practice exercises, achievement displays, etc.
 */

import React from 'react';
import { Box, Text } from '@gluestack-ui/themed';
import { useDisplayTheme } from '../../hooks/useDisplayTheme';

const BASE_LABEL_SIZE = 12;

type PillStatus = 'high' | 'medium' | 'low' | 'not-started';

interface StatusPillProps {
  status: PillStatus;
  label: string;
}

function getPillColors(status: PillStatus, isDark: boolean) {
  switch (status) {
    case 'high':
      return { bg: '#D1FAE5', color: '#065F46' };
    case 'medium':
      return { bg: '#FEF3C7', color: '#92400E' };
    case 'low':
      return { bg: '#FEE2E2', color: '#991B1B' };
    case 'not-started':
      return isDark
        ? { bg: '#374151', color: '#D1D5DB' }
        : { bg: '#F3F4F6', color: '#6B7280' };
  }
}

export function StatusPill({ status, label }: StatusPillProps) {
  const { theme: t, fontScale, ffs } = useDisplayTheme();
  const colors = getPillColors(status, t.isDark);

  return (
    <Box px="$3" py="$1" rounded="$full" style={{ backgroundColor: colors.bg }}>
      <Text
        allowFontScaling={false}
        style={{ fontSize: BASE_LABEL_SIZE * fontScale, fontWeight: '600', color: colors.color, ...ffs }}
      >
        {label}
      </Text>
    </Box>
  );
}
